// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__3nnM7","app":"Main_app__ZaHkX","content":"Main_content__2K0G4"};